import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';

const useTimezone = () => {
  const { user } = useAuth();

  const browserTimezone = useMemo(
    () => Intl.DateTimeFormat().resolvedOptions().timeZone,
    []
  );

  const effectiveTimezone = user?.timezone || browserTimezone;

  const abbreviation = useMemo(() => {
    try {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: effectiveTimezone,
        timeZoneName: 'short',
      }).formatToParts(new Date());
      const tzPart = parts.find((p) => p.type === 'timeZoneName');
      return tzPart?.value || effectiveTimezone;
    } catch {
      return effectiveTimezone;
    }
  }, [effectiveTimezone]);

  return { effectiveTimezone, browserTimezone, abbreviation };
};

export default useTimezone;
